// NEXIS Virtual Lab — bilingual strings (PT default, EN).
export const LAB_STRINGS = {
  pt: {
    // chrome
    "app.name": "Virtual Lab",
    "app.tagline": "Network Engineering · Simulation & Field Intelligence",
    "app.subtitle": "Infraestrutura de Conectividade",
    "nav.dashboard": "Dashboard",
    "nav.projects": "Projetos",
    "nav.signal": "Signal Lab",
    "nav.network": "Network Designer",
    "nav.experiments": "Experiências",
    "nav.energy": "HX Stable Energy",
    "nav.reports": "Relatórios",
    "nav.team": "Gestão de Equipa",
    "nav.history": "Histórico",
    "nav.settings": "Definições",
    "footer.region": "São Tomé e Príncipe",
    "footer.region_sub": "Connected Opportunities",
    "header.actions": "Explorar · Desenhar · Testar · Reportar",
    "sim.badge": "DADOS SIMULADOS",
    "sim.disclaimer": "DADOS SIMULADOS — NÃO É UMA MEDIÇÃO REAL DE CAMPO",
    "common.back": "Voltar",
    "common.save": "Guardar",
    "common.cancel": "Cancelar",
    "common.create": "Criar",
    "common.delete": "Eliminar",
    "common.edit": "Editar",
    "common.open": "Abrir",
    "common.close": "Fechar",
    "common.add": "Adicionar",
    "common.none": "Nenhum",
    "common.active": "Ativo",
    "common.status": "Estado",
    "common.category": "Categoria",
    "common.name": "Nome",
    "common.location": "Localização",
    "common.notes": "Observações",
    "common.run": "Executar",
    "common.reset": "Repor",
    "status.simulated": "Simulado",
    "status.field": "Em campo",
    // dashboard
    "dash.title": "Dashboard de Engenharia",
    "dash.subtitle": "Visão geral das simulações e projetos virtuais",
    "dash.projects": "Projetos",
    "dash.scenarios": "Cenários de teste",
    "dash.topologies": "Topologias",
    "dash.reports": "Relatórios",
    "dash.experiments": "Experiências concluídas",
    "dash.recent": "Atividade recente",
    "dash.current_project": "Projeto atual",
    "dash.quick_signal": "Signal Intelligence",
    "dash.open_project": "Abrir projeto",
    "dash.no_activity": "Sem atividade registada ainda.",
    "dash.sim_count": "{n} simulados",
    // projects
    "proj.title": "Projetos Virtuais",
    "proj.subtitle": "Crie e gira projetos de engenharia de rede",
    "proj.new": "Novo projeto",
    "proj.new_title": "Criar projeto virtual",
    "proj.name_ph": "ex.: Resort Virtual 02 — São Tomé",
    "proj.location_ph": "Localização fictícia (ex.: São Tomé e Príncipe)",
    "proj.zones": "Zonas / Edifícios",
    "proj.zones_ph": "Separe por vírgulas: Receção, Quartos, Jardim",
    "proj.engineers": "Engenheiros atribuídos",
    "proj.empty": "Ainda não há projetos. Crie o primeiro.",
    "proj.deleted": "Projeto eliminado",
    "proj.created": "Projeto criado",
    "proj.set_active": "Definir como atual",
    "proj.is_active": "Projeto atual",
    "proj.confirm_del": "Eliminar este projeto e todos os seus dados simulados?",
    // signal
    "sig.title": "Signal Intelligence Lab",
    "sig.subtitle": "Análise sintética de sinal móvel 3G / 4G / 5G",
    "sig.operator": "Operadora",
    "sig.technology": "Tecnologia",
    "sig.band": "Banda",
    "sig.freq": "Frequência (MHz)",
    "sig.add": "Adicionar medição",
    "sig.history": "Histórico de medições",
    "sig.compare": "Comparação de operadoras",
    "sig.no_measure": "Sem medições. Adicione a primeira.",
    "sig.grade": "Qualidade",
    "sig.grade.excellent": "Excelente",
    "sig.grade.good": "Boa",
    "sig.grade.fair": "Razoável",
    "sig.grade.poor": "Fraca",
    "sig.added": "Medição simulada adicionada",
    "sig.origin": "Origem",
    "sig.timestamp": "Data/Hora",
    "sig.mode_sim": "Simulador",
    "sig.mode_field": "Campo (manual)",
    "sig.field_hint": "Introduza valores lidos no terreno (ex.: app Cellular-Z) e anexe a captura.",
    "sig.upload": "Carregar captura (Cellular-Z)",
    "sig.change_img": "Trocar imagem",
    "sig.remove_img": "Remover",
    "sig.add_field": "Adicionar medição de campo",
    "sig.field_added": "Medição de campo adicionada",
    "sig.badge_sim": "SIM",
    "sig.badge_field": "CAMPO",
    "sig.field_data": "DADOS DE CAMPO (introdução manual)",
    "sig.screenshot": "Captura",
    "common.loading": "A carregar…",
    "sig.loc": "Localização",
    "sig.loc_ph": "ex.: Receção, Piso 2, Jardim",
    "sig.verified": "Verificado",
    "sig.unverified": "Não verificado",
    "sig.mark_verified": "Marcar como verificado",
    "sig.diag_title": "Diagnóstico automático do sinal",
    "sig.diag_sub": "Regras determinísticas e transparentes — sem IA",
    "sig.diag_overall": "Estado geral",
    "sig.diag_none": "Introduza RSRP, RSRQ ou SINR para diagnosticar.",
    "sig.diag_rule": "Critério",
    "sig.rec_title": "Recomendações técnicas",
    "sig.rec_causes": "Possíveis causas",
    "sig.rec_measures": "Medições adicionais sugeridas",
    "sig.rec_steps": "Passos de resolução",
    "sig.realcompare_title": "CST vs Unitel — dados reais de campo",
    "sig.realcompare_sub": "Compara medições manuais da mesma localização, tecnologia e dia. Os dados simulados são mantidos à parte.",
    "sig.realcompare_none": "Ainda não há dados de campo suficientes. Registe leituras CST e Unitel na mesma localização, tecnologia e dia (separador Campo).",
    "sig.sim_compare_note": "Comparação SIMULADA (determinística) — não representa cobertura real.",
    "sig.better": "Melhor",
    "sig.tie": "Igual",
    "sig.await_other": "Aguarda medição da outra operadora",
    "sig.period": "Dia",
    "lvl.good": "Bom",
    "lvl.fair": "Razoável",
    "lvl.warning": "Fraco",
    "lvl.critical": "Crítico",
    "rule.rsrp.good": "RSRP forte — boa cobertura",
    "rule.rsrp.fair": "RSRP moderado — cobertura aceitável",
    "rule.rsrp.warning": "RSRP fraco — cobertura limitada",
    "rule.rsrp.critical": "RSRP muito fraco — cobertura deficiente",
    "rule.rsrq.good": "RSRQ bom — qualidade estável",
    "rule.rsrq.fair": "RSRQ moderado — alguma degradação",
    "rule.rsrq.warning": "RSRQ fraco — possível congestão/interferência",
    "rule.rsrq.critical": "RSRQ crítico — qualidade muito degradada",
    "rule.sinr.good": "SINR bom — pouca interferência",
    "rule.sinr.fair": "SINR moderado — interferência ligeira",
    "rule.sinr.warning": "SINR fraco — interferência elevada",
    "rule.sinr.critical": "SINR crítico — interferência severa",
    "rc.cause.distance": "Distância elevada à antena / célula",
    "rc.cause.obstruction": "Obstáculos físicos (paredes, terreno, vegetação)",
    "rc.cause.congestion": "Congestão da rede / hora de ponta",
    "rc.cause.interference": "Interferência de outras células ou fontes",
    "rc.cause.overlap": "Sobreposição de células (conflito de PCI)",
    "rc.cause.none": "Sem problemas relevantes detetados",
    "rc.meas.repeat_offpeak": "Repetir a medição fora da hora de ponta",
    "rc.meas.other_band": "Medir noutra banda / tecnologia",
    "rc.meas.other_locations": "Medir em vários pontos da zona",
    "rc.meas.pci_scan": "Verificar PCIs vizinhos / varredura de células",
    "rc.step.reposition": "Reposicionar o equipamento / antena interna",
    "rc.step.external_antenna": "Considerar antena externa direcional",
    "rc.step.change_band": "Mudar de banda ou canal",
    "rc.step.reduce_interf": "Reduzir fontes de interferência próximas",
    "rc.step.none": "Nenhuma ação necessária — sinal saudável",
    // network
    "net.title": "Network Designer",
    "net.subtitle": "Editor interativo de topologia de rede",
    "net.palette": "Equipamentos",
    "net.add_hint": "Clique num equipamento para o adicionar ao diagrama",
    "net.save": "Guardar topologia",
    "net.saved": "Topologia guardada",
    "net.clear": "Limpar",
    "net.validate": "Validar",
    "net.valid": "Topologia válida",
    "net.invalid": "Problemas de topologia detetados",
    "net.node_props": "Propriedades do nó",
    "net.node_label": "Etiqueta",
    "net.delete_node": "Eliminar nó",
    "net.connect_hint": "Arraste de um nó para outro para ligar",
    "net.no_project": "Selecione um projeto para desenhar a topologia.",
    // experiments
    "exp.title": "Experiment & Failure Lab",
    "exp.subtitle": "Cenários de falha determinísticos e reproduzíveis",
    "exp.scenario": "Cenário",
    "exp.params": "Parâmetros",
    "exp.results": "Resultados (simulação)",
    "exp.run": "Executar teste",
    "exp.availability": "Disponibilidade da rede",
    "exp.downtime": "Tempo de falha",
    "exp.latency": "Latência média",
    "exp.loss": "Perda de pacotes",
    "exp.affected": "Utilizadores afetados",
    "exp.overall": "Estado geral",
    "exp.log": "Registo de eventos",
    "exp.save": "Guardar experiência",
    "exp.saved": "Experiência guardada",
    "exp.twin_title": "Gémeo Digital ao vivo",
    "exp.twin_sub": "Reage aos controlos abaixo em tempo real · usa a topologia do Network Designer",
    "exp.twin_no_topo": "Este projeto ainda não tem topologia. Crie-a no Network Designer.",
    "exp.twin_controls": "Controlos rápidos",
    "exp.twin_legend": "Legenda",
    "exp.lm_title": "Métricas ao vivo",
    "exp.throughput": "Débito",
    "tw.active": "Ativo",
    "tw.warning": "Aviso",
    "tw.failure": "Falha",
    "tw.offline": "Offline",
    "exp.p.ispDown": "Desligar ISP principal",
    "exp.p.backupActive": "Ativar ligação de reserva",
    "exp.p.apDown": "Desativar um Access Point",
    "exp.p.latencyUp": "Simular aumento de latência",
    "exp.p.packetLoss": "Simular perda de pacotes",
    "exp.p.powerLoss": "Simular falha de energia",
    "exp.s.primary_isp_outage": "Falha de ligação principal (ISP)",
    "exp.s.backup_activation": "Ativação de internet de reserva",
    "exp.s.ap_failure": "Falha de Access Point",
    "exp.s.increased_latency": "Aumento de latência",
    "exp.s.packet_loss": "Perda de pacotes",
    "exp.s.power_interruption": "Interrupção de energia",
    "exp.s.ups_operation": "Operação em UPS",
    "st.stable": "Estável",
    "st.degraded": "Degradado",
    "st.critical": "Crítico",
    "st.offline": "Offline",
    "log.isp_down": "ISP principal desligado",
    "log.backup_engaged": "Ligação de reserva ativada",
    "log.service_restored_backup": "Serviço restaurado via reserva",
    "log.total_outage": "Interrupção total — sem reserva",
    "log.ap_offline": "Access Point offline",
    "log.latency_spike": "Pico de latência detetado",
    "log.packet_loss": "Perda de pacotes acima do limiar",
    "log.power_lost": "Energia da rede perdida",
    "log.ups_holding": "UPS a sustentar a carga crítica",
    "scenario.start": "Início da simulação",
    "scenario.end": "Fim da simulação",
    // reports
    "rep.title": "Engineering Reports",
    "rep.subtitle": "Gere relatórios técnicos bilingues em PDF",
    "rep.include": "Secções a incluir",
    "rep.i.summary": "Resumo do projeto",
    "rep.i.topology": "Topologia da rede",
    "rep.i.signal": "Dados de sinal (CST / Unitel)",
    "rep.i.scenarios": "Resultados dos cenários",
    "rep.i.recommendations": "Recomendações técnicas",
    "rep.i.nextsteps": "Próximos passos",
    "rep.language": "Idioma do relatório",
    "rep.generate": "Gerar relatório PDF",
    "rep.history": "Relatórios gerados",
    "rep.generated": "Relatório PDF gerado",
    "rep.no_project": "Selecione um projeto para gerar relatórios.",
    "rep.select_project": "Projeto",
    // team
    "team.title": "Equipa de Engenharia",
    "team.subtitle": "Perfis de demonstração — sem contas reais nesta versão",
    "team.role.bsgotech_admin": "BSGOTECH Admin",
    "team.role.tecnon_engineer": "TecNon Engineer",
    "team.role.external_reviewer": "External Reviewer",
    "team.perm.bsgotech_admin": "Gestão total · utilizadores · projetos · aprovação de relatórios",
    "team.perm.tecnon_engineer": "Projetos atribuídos · criar/editar simulações · observações",
    "team.perm.external_reviewer": "Apenas leitura de relatórios partilhados",
    "team.note": "Esta versão V0.1 é um protótipo frontend. Os papéis são ilustrativos e NÃO impõem segurança real sem backend.",
    // settings
    "set.title": "Definições",
    "set.subtitle": "Preferências do protótipo (guardadas neste navegador)",
    "set.language": "Idioma da interface",
    "set.data": "Dados de demonstração",
    "set.reset_demo": "Repor dados de demonstração",
    "set.reset_done": "Dados de demonstração repostos",
    "set.about": "Sobre",
    "set.about_text": "NEXIS Virtual Lab V0.1 — protótipo frontend isolado. Desenvolvido por BSGOTECH. Colaboração técnica proposta com TecNon. Todos os dados são sintéticos.",
    "sync.title": "Sincronização & Backup",
    "sync.online": "Sincronizado com o servidor da equipa",
    "sync.connecting": "A ligar ao servidor…",
    "sync.offline": "Offline — a trabalhar localmente",
    "sync.last": "Última sincronização",
    "sync.about": "Os projetos, zonas, plantas, medições, fotografias e relatórios são partilhados por toda a Equipa TecNon e sincronizados entre dispositivos. É mantida também uma cópia local neste navegador.",
    "sync.migration_prompt": "Foram encontrados dados locais neste dispositivo que ainda não estão no servidor. Faça uma cópia de segurança e importe-os para partilhar com a equipa. Nada será apagado.",
    "sync.migrate": "Fazer backup e migrar para o servidor",
    "sync.migrated": "Migração concluída: {n} projeto(s) importado(s), {s} ignorado(s).",
    "sync.backup_local": "Descarregar backup (local)",
    "sync.backup_server": "Descarregar backup (servidor)",
    "sync.backup_done": "Backup descarregado.",
    "sync.error": "Ocorreu um erro. Tente novamente.",
    "sync.reset_warning": "Repõe apenas a cópia local deste navegador para o estado de demonstração. Os dados do servidor da equipa não são afetados.",
    "hist.title": "Histórico de alterações",
    "hist.subtitle": "Registo de quem alterou o quê, por projeto.",
    "hist.refresh": "Atualizar",
    "hist.recent": "Atividade recente",
    "hist.all_projects": "Todos os projetos",
    "hist.empty": "Ainda não há atividade registada.",
    "pwd.title": "Alterar a minha senha",
    "pwd.about": "Altere a senha da sua própria conta. Precisa da senha atual. A nova senha deve ter pelo menos 8 caracteres.",
    "pwd.current": "Senha atual",
    "pwd.new": "Nova senha",
    "pwd.confirm": "Confirmar nova senha",
    "pwd.save": "Guardar nova senha",
    "pwd.done": "Senha alterada com sucesso.",
    "pwd.min8": "A nova senha deve ter pelo menos 8 caracteres.",
    "pwd.mismatch": "As senhas não coincidem.",
    "pwd.wrong_current": "Senha atual incorreta.",
    "pwd.error": "Não foi possível alterar a senha. Tente novamente.",
    "nrg.subtitle": "Avaliação técnica solar / BESS · dados locais do protótipo",
    "nrg.local_note": "Dados guardados apenas neste navegador (sem backend). Use Exportar para criar uma cópia de segurança.",
    "nrg.assessment": "Avaliação técnica",
    "nrg.checklist": "Checklist de equipamento",
    "nrg.photos": "Fotografias",
    "nrg.generate_pdf": "Gerar PDF",
    "nrg.export": "Exportar backup",
    "nrg.import": "Importar backup",
    "nrg.exported": "Backup exportado (JSON)",
    "nrg.imported": "Projeto importado",
    "nrg.import_err": "Ficheiro inválido",
    "nrg.pdf_generated": "Relatório HX gerado",
    "nrg.site": "Nome do local",
    "nrg.solar_kwp": "Solar (kWp)",
    "nrg.battery_kwh": "Bateria (kWh)",
    "nrg.pv_modules": "Nº de módulos PV",
    "nrg.inverter": "Inversor (modelo genérico)",
    "nrg.system_voltage": "Tensão do sistema",
    "nrg.notes": "Observações técnicas",
    "nrg.group.solar": "Solar fotovoltaico",
    "nrg.group.bess": "Armazenamento (BESS)",
    "nrg.status.ok": "OK",
    "nrg.status.issue": "Problema",
    "nrg.status.na": "N/A",
    "nrg.add_photos": "Adicionar fotos",
    "nrg.no_photos": "Sem fotos. Adicione a partir da galeria ou do computador.",
    "nrg.caption_ph": "Legenda (opcional)",
    "nrg.photos_count": "{n} foto(s)",
    "nrg.ck.panels_mounted": "Painéis fixados e seguros",
    "nrg.ck.panel_orientation": "Orientação e inclinação corretas",
    "nrg.ck.string_voltage": "Tensão de string dentro do limite",
    "nrg.ck.mppt_config": "Configuração MPPT verificada",
    "nrg.ck.dc_protection": "Proteções DC (fusíveis/disjuntores)",
    "nrg.ck.pv_grounding": "Ligação à terra do PV",
    "nrg.ck.battery_mounting": "Baterias montadas e fixas",
    "nrg.ck.bms_status": "BMS operacional",
    "nrg.ck.soc_calibration": "Calibração de SOC",
    "nrg.ck.ventilation": "Ventilação / arrefecimento adequados",
    "nrg.ck.ac_protection": "Proteções AC",
    "nrg.ck.inverter_config": "Configuração do inversor",
    "nrg.ck.backup_switchover": "Comutação para backup testada",
    "nrg.ck.labeling_safety": "Etiquetagem e segurança",
    "nrg.survey": "Identificação do levantamento",
    "nrg.engineer": "Engenheiro responsável",
    "nrg.visit_date": "Data da visita",
    "nrg.value": "Valor",
    "nrg.obs": "Observação",
    "nrg.mode.measured": "Medido",
    "nrg.mode.estimated": "Estimado",
    "nrg.mode.simulated": "Simulado",
    "nrg.auth_title": "Autorização de Estudo Técnico",
    "nrg.client": "Dados do cliente",
    "nrg.cl_name": "Cliente",
    "nrg.cl_company": "Empresa",
    "nrg.cl_nif": "NIF",
    "nrg.cl_install": "Local de instalação",
    "nrg.cl_rep": "Representante",
    "nrg.cl_role": "Cargo",
    "nrg.cl_contacts": "Contactos",
    "nrg.cl_date": "Data",
    "nrg.study_option": "Modalidade do estudo",
    "nrg.study_free": "Estudo gratuito",
    "nrg.study_paid": "Estudo remunerado",
    "nrg.take_photo": "Tirar foto",
    "nrg.gallery": "Galeria",
    "nrg.pdf_menu": "Gerar documento",
    "nrg.pdf_auth": "A · Autorização de Estudo",
    "nrg.pdf_report": "B · Relatório Solar/BESS",
    "nrg.pdf_annex": "C · Anexo Fotográfico",
    "nrg.pdf_dossier": "D · Dossiê Técnico Completo",
    "nrg.demo": "PROJETO DE DEMONSTRAÇÃO",
    "auth.login_title": "Entrar no NEXIS Lab",
    "auth.subtitle": "Equipa TecNon · BSGOTECH",
    "auth.email": "Email",
    "auth.password": "Senha",
    "auth.signin": "Entrar",
    "auth.signing": "A entrar…",
    "auth.logout": "Sair",
    "auth.err": "Falha. Verifique as credenciais.",
    "auth.set_title": "Definir a sua senha",
    "auth.new_password": "Nova senha",
    "auth.confirm_password": "Confirmar senha",
    "auth.save": "Guardar senha",
    "auth.set_done": "Senha definida. A redirecionar para o login…",
    "auth.mismatch": "As senhas não coincidem.",
    "auth.min8": "Mínimo de 8 caracteres.",
    "auth.invalid_link": "Link inválido ou expirado.",
    "tm.tab_team": "Equipa",
    "tm.tab_access": "Email e Senha",
    "tm.engineers": "Engenheiros TecNon",
    "tm.add_eng": "Adicionar engenheiro",
    "tm.name": "Nome completo",
    "tm.email": "Email profissional",
    "tm.create_access": "Criar acesso",
    "tm.reset": "Repor senha",
    "tm.revoke": "Revogar",
    "tm.delete": "Eliminar",
    "tm.active": "Ativo",
    "tm.inactive": "Inativo",
    "tm.activate": "Ativar",
    "tm.deactivate": "Desativar",
    "tm.pending_pw": "Senha por definir",
    "tm.pw_set": "Acesso ativo",
    "tm.last_login": "Último acesso",
    "tm.never": "Nunca",
    "tm.link_copy": "Copiar",
    "tm.link_hint": "Envie este link único (24h) ao engenheiro para definir a senha.",
    "tm.copied": "Link copiado",
    "tm.admin_only": "Apenas o BSGOTECH Admin pode gerir acessos.",
    "tm.management_title": "Gestão de Equipa",
    "tm.management_subtitle": "Administre engenheiros, convites, papéis e segurança da equipa TecNon.",
    "tm.tab_engineers": "Engenheiros",
    "tm.tab_add": "Adicionar Engenheiro",
    "tm.tab_pending": "Convites Pendentes",
    "tm.tab_roles": "Papéis & Permissões",
    "tm.tab_security": "Segurança",
    "tm.expiry": "Validade do convite",
    "tm.expiry_24h": "24 horas",
    "tm.expiry_48h": "48 horas",
    "tm.expiry_7d": "7 dias",
    "tm.expiry_30d": "30 dias",
    "tm.expires": "Expira",
    "tm.edit": "Editar",
    "tm.save": "Guardado",
    "tm.cancel": "Cancelar",
    "tm.regenerate": "Regenerar link",
    "tm.no_pending": "Não há convites pendentes.",
    "tm.purpose_invite": "Convite inicial",
    "tm.purpose_reset": "Redefinição de senha",
    "tm.audit": "Registo de auditoria",
    "tm.no_audit": "Ainda não há registos.",
    "tm.role_admin": "ADMINISTRADOR",
    "tm.role_engineer": "ENGENHEIRO",
    "tm.admin_perms": "Administração total da plataforma\nGerir engenheiros e convites\nGerir projetos, documentos e definições\nVer painéis administrativos\nControlo de todas as permissões",
    "tm.eng_perms": "Aceder aos projetos de engenharia atribuídos\nCarregar relatórios e documentos técnicos\nAtualizar informação técnica dos projetos\nVer tarefas atribuídas\nSem acesso a Definições de Admin, gestão de utilizadores ou atribuição de papéis",
    "tm.security_note": "As permissões são aplicadas no backend. O Admin legítimo está protegido e não pode ser rebaixado nem removido por engenheiros. Contas desativadas perdem a sessão de imediato. Os tokens de convite nunca são expostos nos registos.",
    "tm.invite_subject": "Convite para a plataforma NEXIS (BSGOTECH)",
    "tm.invite_body": "Foi convidado para a plataforma NEXIS da BSGOTECH. Abra o link para definir a sua senha e entrar:",
    "prof.title": "Meu Perfil",
    "prof.name": "Nome",
    "prof.email": "Email",
    "prof.role": "Papel",
    "prof.role_admin": "Administrador",
    "prof.role_engineer": "Engenheiro TecNon",
    "prof.role_admin_full": "BSGOTECH Administrator",
    "prof.photo": "Foto",
    "prof.save": "Guardar perfil",
    "prof.saved": "Perfil atualizado.",
    "prof.name_required": "Introduza um nome.",
    "prof.note": "Isto altera apenas o seu nome e foto. As suas permissões não são alteradas.",


    "tm.no_engineers": "Sem engenheiros. Adicione o primeiro.",
    // --- Signal Zones ---
    "sz.title": "Zonas de Sinal",
    "sz.add": "Adicionar Zona de Sinal",
    "sz.add_more": "Adicionar mais zonas",
    "sz.add_more_sub": "Pode adicionar quantas zonas forem necessárias",
    "sz.total": "Total de Zonas",
    "sz.verified": "Verificadas",
    "sz.pending": "Pendentes",
    "sz.nosignal": "Sem Sinal",
    "sz.open_lab": "Signal Lab",
    "sz.edit": "Editar Zona",
    "sz.duplicate": "Duplicar",
    "sz.archive": "Arquivar",
    "sz.unarchive": "Desarquivar",
    "sz.delete": "Eliminar",
    "sz.move_up": "Mover para cima",
    "sz.move_down": "Mover para baixo",
    "sz.none_selected": "Selecione uma zona para abrir o seu Signal Lab.",
    "sz.no_zones": "Ainda não há zonas. Adicione a primeira zona de sinal.",
    "sz.show_archived": "Mostrar arquivadas",
    "sz.zone": "Zona",
    "sz.tab.overview": "Visão Geral",
    "sz.tab.meas": "Medições",
    "sz.tab.photos": "Fotografias",
    "sz.tab.map": "Mapa",
    "sz.tab.notes": "Observações",
    "sz.f.name": "Nome da zona",
    "sz.f.type": "Tipo de zona",
    "sz.f.area": "Área aproximada (m²)",
    "sz.f.desc": "Descrição",
    "sz.f.lat": "Latitude",
    "sz.f.lng": "Longitude",
    "sz.f.location": "Localização",
    "sz.f.operator": "Operador",
    "sz.f.connType": "Tipo de ligação",
    "sz.f.wifiTech": "Tecnologia Wi-Fi",
    "sz.f.status": "Estado do levantamento",
    "sz.f.coverage": "Classificação de cobertura",
    "sz.f.coverage_mode": "Modo de classificação",
    "sz.f.observations": "Observações",
    "sz.f.problems": "Problemas identificados",
    "sz.f.recommendations": "Recomendações",
    "sz.info": "Informações da Zona",
    "sz.loc": "Localização",
    "sz.opnet": "Operador e Rede",
    "sz.last_meas": "Última Medição (manual)",
    "sz.no_meas": "Sem medições registadas.",
    "sz.wifi": "Wi-Fi",
    "sz.mobile": "Redes móveis 4G/5G",
    "sz.add_wifi": "Adicionar Wi-Fi",
    "sz.add_mobile": "Adicionar móvel",
    "sz.add_meas": "Adicionar Nova Medição",
    "sz.add_photos": "Adicionar Fotografias",
    "sz.gen_zone_pdf": "Gerar Relatório PDF",
    "sz.w.band": "Frequência",
    "sz.w.channel": "Canal",
    "sz.w.rssi": "RSSI (dBm)",
    "sz.w.download": "Download (Mbps)",
    "sz.w.upload": "Upload (Mbps)",
    "sz.w.latency": "Latência (ms)",
    "sz.w.point": "Ponto de medição",
    "sz.m.point": "Ponto de medição",
    "sz.map_title": "Mapa de Zonas de Sinal",
    "sz.map_upload": "Carregar mapa / planta",
    "sz.map_change": "Alterar mapa",
    "sz.map_remove": "Remover mapa",
    "sz.map_none": "Sem mapa. Carregue uma planta ou mapa do local.",
    "sz.map_note": "Associe fotografias e localização às zonas. Coordenadas e áreas não são inventadas.",
    "bp.upload_image": "Imagem (PNG/JPG)",
    "bp.upload_pdf": "PDF",
    "bp.pages": "Pisos / Páginas",
    "bp.floor_ph": "Nome do piso",
    "bp.remove_page": "Remover",
    "bp.zoom_in": "Ampliar",
    "bp.zoom_out": "Reduzir",
    "bp.zoom_reset": "Repor",
    "bp.place_zones": "Colocar zonas",
    "bp.place_hint": "Toque na planta para colocar a zona selecionada.",
    "bp.add_point": "Adicionar ponto",
    "bp.point_hint": "Toque na planta para adicionar um ponto de medição à zona selecionada.",
    "bp.no_plan": "Sem planta. Carregue uma imagem ou PDF do local.",
    "bp.pdf_loading": "A processar PDF…",
    "bp.pdf_error": "Não foi possível ler o PDF. Carregue PNG/JPG ou tente outro ficheiro.",
    "bp.unplaced": "Zonas por colocar",
    "bp.create_meas_wifi": "Criar medição Wi-Fi",
    "bp.create_meas_mobile": "Criar medição 4G/5G",
    "bp.open_lab": "Abrir Signal Lab",
    "bp.point_coverage": "Cobertura do ponto",
    "bp.layers": "Camadas",
    "bp.layer_zones": "Zonas",
    "bp.layer_points": "Pontos de medição",
    "bp.legend": "Legenda",
    "bp.remove_marker": "Retirar da planta",
    "bp.select_zone_first": "Selecione primeiro uma zona na lista.",
    "bp.plan_in_report": "A planta anotada é incluída no relatório PDF.",
    "sz.photos_title": "Fotografias da Zona",
    "sz.no_photos_zone": "Sem fotografias nesta zona.",
    "sz.meas_history": "Histórico de Medições",
    "sz.caption_ph": "Legenda...",
    "sz.no_value": "Não exigido — deixe em branco se não medido",
    "sz.class_hint": "Classifique a origem de cada valor.",
    "sz.simlab_title": "Laboratório de Simulação",
    "sz.simlab_sub": "Simulação determinística CST/Unitel — dados simulados, não é medição real.",
    "sz.simlab_toggle": "Mostrar/ocultar",
    "cov.strong": "Sinal forte",
    "cov.medium": "Sinal médio",
    "cov.weak": "Sinal fraco",
    "cov.none": "Sem sinal",
    "cov.unverified": "Não verificado",
    "cov.manual": "Manual",
    "cov.computed": "Calculado",
    "zt.reception": "Receção",
    "zt.rooms": "Quartos",
    "zt.restaurant": "Restaurante / Bar",
    "zt.pool": "Piscina",
    "zt.garden": "Jardim",
    "zt.beach": "Praia",
    "zt.office": "Escritório",
    "zt.parking": "Estacionamento",
    "zt.exterior": "Exterior",
    "zt.technical": "Área técnica",
    "zt.other": "Outro",
    "zst.pending": "Pendente",
    "zst.verified": "Verificada",
    "zst.archived": "Arquivada",
    "rep.export_a": "PDF do Projeto Completo",
    "rep.export_b": "PDF de Zona Individual",
    "rep.export_c": "PDF Consolidado (Zonas)",
    "rep.select_zone": "Selecionar zona",
    "rep.no_zones": "O projeto não tem zonas de sinal.",
    "rep.i.zones": "Secções por Zona de Sinal",
    "rep.c.title": "Relatório Consolidado de Cobertura",
    "rep.c.summary": "Resumo Comparativo das Zonas",
    // --- HX Stable Energy v2 ---
    "nrg.doc_a_title": "Documento A · Autorização de Estudo Técnico Preliminar",
    "nrg.doc_b_title": "Documento B · Ficha de Levantamento Técnico Solar/BESS",
    "nrg.auth_status": "Estado da autorização",
    "nrg.auth.pending": "Pendente",
    "nrg.auth.sent": "Enviada",
    "nrg.auth.signed": "Assinada",
    "nrg.minuta_note": "Documento A gera a Solicitação e Autorização de Estudo Técnico Preliminar oficial da BSGOTECH | HX Stable Energy (2 páginas, 9 secções), com o texto integral do documento original. Os dados do cliente, a modalidade e as assinaturas são preenchidos a partir deste formulário.",
    "nrg.preliminary": "AVALIAÇÃO TÉCNICA PRELIMINAR",
    "nrg.sec.a": "A · Identificação da instalação",
    "nrg.sec.b": "B · Consumo energético",
    "nrg.sec.c": "C · Perfil de carga",
    "nrg.sec.d": "D · Rede elétrica",
    "nrg.sec.e": "E · Geradores existentes",
    "nrg.sec.f": "F · Interrupções e autonomia",
    "nrg.sec.g": "G · Cargas críticas",
    "nrg.sec.h": "H · Área para instalação solar",
    "nrg.sec.i": "I · Área de instalação BESS",
    "nrg.sec.j": "J · Equipamentos Solar/BESS existentes",
    "nrg.sec.analysis": "Análise Preliminar Solar/BESS",
    "nrg.sec.flow": "Fluxo operacional",
    // A
    "f.projectCode": "Código único do projeto",
    "f.installName": "Nome da instalação",
    "f.installType": "Tipo de instalação",
    "f.gps": "Coordenadas GPS",
    "f.techContact": "Contacto técnico local",
    "f.visitTime": "Hora da visita",
    "f.assessmentStatus": "Estado da avaliação",
    // B
    "f.monthlyKwh": "Consumo mensal (kWh)",
    "f.invoiceHistory": "Histórico de faturas disponível",
    "f.avgDailyKwh": "Consumo médio diário (kWh)",
    "f.peakKw": "Potência de pico (kW/kVA)",
    "f.contractedPower": "Potência contratada/disponível",
    "f.peakHours": "Horários de maior consumo",
    "f.mainLoads": "Principais equipamentos consumidores",
    "f.energyCost": "Custo de eletricidade",
    // C
    "f.loadProfileSource": "Origem dos dados de carga",
    "f.loadProfileNotes": "Notas do perfil de carga",
    // D
    "f.supplyType": "Tipo de alimentação",
    "f.nominalVoltage": "Tensão nominal",
    "f.frequency": "Frequência (Hz)",
    "f.phases": "Número de fases",
    "f.transformer": "Transformador existente",
    "f.transformerCapacity": "Capacidade do transformador",
    "f.mainBoard": "Quadro geral / distribuição",
    "f.protections": "Proteções existentes",
    "f.visualState": "Estado visual das instalações",
    "f.connectionPoints": "Pontos de ligação disponíveis",
    "f.singleLine": "Diagrama unifilar (existe?)",
    // E generator
    "f.maker": "Fabricante",
    "f.model": "Modelo",
    "f.powerKva": "Potência (kVA/kW)",
    "f.fuel": "Combustível",
    "f.consumption": "Consumo de combustível",
    "f.hours": "Horas de funcionamento",
    "f.condition": "Condição operacional",
    "f.switchgear": "Comutação rede/gerador",
    "f.autoManual": "Automático/Manual",
    // F
    "f.outageFrequency": "Frequência das interrupções",
    "f.outageDuration": "Duração habitual",
    "f.failureHistory": "Histórico real de falhas",
    "f.infoOrigin": "Origem da informação",
    "f.affectedEquip": "Equipamentos afetados",
    "f.continuityNeeds": "Necessidades de continuidade",
    "f.desiredAutonomyH": "Autonomia pretendida (h)",
    "f.loadPriority": "Prioridade das cargas a sustentar",
    // G critical load
    "f.cl_name": "Equipamento",
    "f.cl_qty": "Quantidade",
    "f.cl_power": "Potência nominal",
    "f.cl_hours": "Horas de utilização",
    "f.cl_priority": "Prioridade",
    "f.cl_backup": "Necessita backup",
    "f.cl_simultaneous": "Funcionamento simultâneo",
    "f.cl_notes": "Observações técnicas",
    // H
    "f.solarSurface": "Superfície (telhado/terreno/outra)",
    "f.solarAreaM2": "Área disponível (m²)",
    "f.orientation": "Orientação",
    "f.tilt": "Inclinação",
    "f.shading": "Sombras e obstáculos",
    "f.structuralState": "Estado estrutural aparente",
    "f.distanceToConn": "Distância aos pontos de ligação",
    // I
    "f.bessLocation": "Local proposto",
    "f.bessSpace": "Espaço disponível",
    "f.bessIndoorOutdoor": "Interior/Exterior",
    "f.ventilation": "Ventilação",
    "f.temperature": "Condições de temperatura",
    "f.accessibility": "Acessibilidade",
    "f.proximityBoard": "Proximidade ao quadro elétrico",
    "f.safetyConditions": "Condições de segurança",
    // analysis
    "f.proposedSolarKwp": "Potência solar proposta (kWp)",
    "f.proposedBessKwh": "Capacidade BESS proposta (kWh)",
    "f.inverterPower": "Potência do inversor",
    "f.desiredAutonomy": "Autonomia pretendida",
    "f.estimatedAutonomy": "Autonomia estimada (se calculável)",
    "f.operationStrategy": "Estratégia preliminar de operação",
    "f.techConstraints": "Restrições técnicas",
    "f.missingData": "Dados em falta",
    "f.nextPhaseRecs": "Recomendações próxima fase",
    "nrg.analysis_note": "Valores PROPOSTOS para análise — não representam equipamento instalado nem dimensionamento definitivo. Sujeito a validação de engenharia.",
    // classification
    "nrg.class": "Classificação",
    "nrg.class.measured": "Medido",
    "nrg.class.documented": "Documentado",
    "nrg.class.estimated": "Estimado",
    "nrg.class.unverified": "Não verificado",
    "nrg.class.simulated": "Simulado",
    // checklist statuses v2
    "nrg.cs.conforme": "Conforme",
    "nrg.cs.nao_conforme": "Não conforme",
    "nrg.cs.nao_verificado": "Não verificado",
    "nrg.cs.nao_aplicavel": "N/A",
    // photo categories
    "nrg.photo_category": "Categoria",
    "pc.counter": "Contador elétrico",
    "pc.main_board": "Quadro geral",
    "pc.transformer": "Transformador",
    "pc.generators": "Geradores",
    "pc.nameplates": "Placas de identificação",
    "pc.bess_location": "Local previsto BESS",
    "pc.solar_area": "Telhado / terreno solar",
    "pc.connection_points": "Pontos de conexão",
    "pc.other": "Outros equipamentos",
    // option labels
    "it.hotel": "Hotel", "it.resort": "Resort", "it.enterprise": "Empresa", "it.commerce": "Comércio", "it.industry": "Indústria", "it.other": "Outro",
    "as.draft": "Rascunho", "as.in_progress": "Em curso", "as.completed": "Concluída", "as.review": "Em revisão interna",
    "st2.grid": "Rede pública", "st2.generator": "Gerador", "st2.hybrid": "Híbrido", "st2.other": "Outro",
    "ph.mono": "Monofásico", "ph.tri": "Trifásico",
    "lps.meter_history": "Histórico do contador", "lps.ems": "Sistema EMS", "lps.manual": "Registo manual", "lps.none": "Sem histórico",
    "pr.high": "Alta", "pr.medium": "Média", "pr.low": "Baixa",
    // misc
    "nrg.add_reading": "Adicionar leitura",
    "nrg.no_readings": "Sem leituras. Registe leituras manuais durante a visita.",
    "nrg.datetime": "Data/Hora",
    "nrg.origin": "Origem",
    "nrg.load_upload": "Carregar ficheiro (CSV/Excel/PDF)",
    "nrg.load_files": "Ficheiros anexados",
    "nrg.load_files_note": "Os nomes dos ficheiros são registados localmente; o conteúdo não é processado automaticamente nesta versão.",
    "nrg.load_chart": "Leituras registadas",
    "nrg.add_generator": "Adicionar gerador",
    "nrg.no_generators": "Sem geradores registados.",
    "nrg.add_load": "Adicionar carga crítica",
    "nrg.no_loads": "Sem cargas críticas registadas.",
    "nrg.remove": "Remover",
    "nrg.backup_q": "Backup",
    "nrg.simul_q": "Simultâneo",
    "nrg.flow.s1": "Criar projeto e cliente",
    "nrg.flow.s2": "Preparar autorização do cliente",
    "nrg.flow.s3": "Registar a situação da autorização",
    "nrg.flow.s4": "Atribuir engenheiro responsável",
    "nrg.flow.s5": "Realizar levantamento pelo telemóvel",
    "nrg.flow.s6": "Adicionar medições e fotografias",
    "nrg.flow.s7": "Guardar rascunho",
    "nrg.flow.s8": "Identificar informações em falta",
    "nrg.flow.s9": "Concluir avaliação preliminar",
    "nrg.flow.s10": "Gerar PDF técnico",
    "nrg.flow.s11": "Submeter para revisão interna BSGOTECH",
    "nrg.flow.s12": "Preparar dados para eventual análise com a Wattzing",
    "nrg.flow_note": "A plataforma não indica que um projeto foi aprovado pela Wattzing sem confirmação específica.",
  },
  en: {
    "app.name": "Virtual Lab",
    "app.tagline": "Network Engineering · Simulation & Field Intelligence",
    "app.subtitle": "Connectivity Infrastructure",
    "nav.dashboard": "Dashboard",
    "nav.projects": "Projects",
    "nav.signal": "Signal Lab",
    "nav.network": "Network Designer",
    "nav.experiments": "Experiments",
    "nav.energy": "HX Stable Energy",
    "nav.reports": "Reports",
    "nav.team": "Team Management",
    "nav.history": "History",
    "nav.settings": "Settings",
    "footer.region": "São Tomé and Príncipe",
    "footer.region_sub": "Connected Opportunities",
    "header.actions": "Explore · Design · Test · Report",
    "sim.badge": "SIMULATED DATA",
    "sim.disclaimer": "SIMULATED DATA — NOT A REAL FIELD MEASUREMENT",
    "common.back": "Back",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.create": "Create",
    "common.delete": "Delete",
    "common.edit": "Edit",
    "common.open": "Open",
    "common.close": "Close",
    "common.add": "Add",
    "common.none": "None",
    "common.active": "Active",
    "common.status": "Status",
    "common.category": "Category",
    "common.name": "Name",
    "common.location": "Location",
    "common.notes": "Notes",
    "common.run": "Run",
    "common.reset": "Reset",
    "status.simulated": "Simulated",
    "status.field": "Field",
    "dash.title": "Engineering Dashboard",
    "dash.subtitle": "Overview of simulations and virtual projects",
    "dash.projects": "Projects",
    "dash.scenarios": "Test scenarios",
    "dash.topologies": "Topologies",
    "dash.reports": "Reports",
    "dash.experiments": "Completed experiments",
    "dash.recent": "Recent activity",
    "dash.current_project": "Current project",
    "dash.quick_signal": "Signal Intelligence",
    "dash.open_project": "Open project",
    "dash.no_activity": "No activity recorded yet.",
    "dash.sim_count": "{n} simulated",
    "proj.title": "Virtual Projects",
    "proj.subtitle": "Create and manage network engineering projects",
    "proj.new": "New project",
    "proj.new_title": "Create virtual project",
    "proj.name_ph": "e.g. Resort Virtual 02 — São Tomé",
    "proj.location_ph": "Fictional location (e.g. São Tomé and Príncipe)",
    "proj.zones": "Zones / Buildings",
    "proj.zones_ph": "Comma separated: Reception, Rooms, Garden",
    "proj.engineers": "Assigned engineers",
    "proj.empty": "No projects yet. Create the first one.",
    "proj.deleted": "Project deleted",
    "proj.created": "Project created",
    "proj.set_active": "Set as current",
    "proj.is_active": "Current project",
    "proj.confirm_del": "Delete this project and all its simulated data?",
    "sig.title": "Signal Intelligence Lab",
    "sig.subtitle": "Synthetic 3G / 4G / 5G mobile signal analysis",
    "sig.operator": "Operator",
    "sig.technology": "Technology",
    "sig.band": "Band",
    "sig.freq": "Frequency (MHz)",
    "sig.add": "Add measurement",
    "sig.history": "Measurement history",
    "sig.compare": "Operator comparison",
    "sig.no_measure": "No measurements. Add the first one.",
    "sig.grade": "Quality",
    "sig.grade.excellent": "Excellent",
    "sig.grade.good": "Good",
    "sig.grade.fair": "Fair",
    "sig.grade.poor": "Poor",
    "sig.added": "Simulated measurement added",
    "sig.origin": "Origin",
    "sig.timestamp": "Timestamp",
    "sig.mode_sim": "Simulator",
    "sig.mode_field": "Field (manual)",
    "sig.field_hint": "Enter values measured in the field (e.g. Cellular-Z app) and attach the screenshot.",
    "sig.upload": "Upload screenshot (Cellular-Z)",
    "sig.change_img": "Change image",
    "sig.remove_img": "Remove",
    "sig.add_field": "Add field measurement",
    "sig.field_added": "Field measurement added",
    "sig.badge_sim": "SIM",
    "sig.badge_field": "FIELD",
    "sig.field_data": "FIELD DATA (manually entered)",
    "sig.screenshot": "Screenshot",
    "common.loading": "Loading…",
    "sig.loc": "Location",
    "sig.loc_ph": "e.g. Reception, Floor 2, Garden",
    "sig.verified": "Verified",
    "sig.unverified": "Unverified",
    "sig.mark_verified": "Mark as verified",
    "sig.diag_title": "Automatic signal diagnostics",
    "sig.diag_sub": "Deterministic, transparent rules — no AI",
    "sig.diag_overall": "Overall state",
    "sig.diag_none": "Enter RSRP, RSRQ or SINR to diagnose.",
    "sig.diag_rule": "Criterion",
    "sig.rec_title": "Technical recommendations",
    "sig.rec_causes": "Possible causes",
    "sig.rec_measures": "Suggested additional measurements",
    "sig.rec_steps": "Troubleshooting steps",
    "sig.realcompare_title": "CST vs Unitel — real field data",
    "sig.realcompare_sub": "Compares manual measurements from the same location, technology and day. Simulated data is kept separate.",
    "sig.realcompare_none": "Not enough field data yet. Record CST and Unitel readings at the same location, technology and day (Field tab).",
    "sig.sim_compare_note": "SIMULATED comparison (deterministic) — does not represent real coverage.",
    "sig.better": "Better",
    "sig.tie": "Tie",
    "sig.await_other": "Awaiting the other operator's measurement",
    "sig.period": "Day",
    "lvl.good": "Good",
    "lvl.fair": "Fair",
    "lvl.warning": "Weak",
    "lvl.critical": "Critical",
    "rule.rsrp.good": "Strong RSRP — good coverage",
    "rule.rsrp.fair": "Moderate RSRP — acceptable coverage",
    "rule.rsrp.warning": "Weak RSRP — limited coverage",
    "rule.rsrp.critical": "Very weak RSRP — poor coverage",
    "rule.rsrq.good": "Good RSRQ — stable quality",
    "rule.rsrq.fair": "Moderate RSRQ — some degradation",
    "rule.rsrq.warning": "Weak RSRQ — possible congestion/interference",
    "rule.rsrq.critical": "Critical RSRQ — heavily degraded quality",
    "rule.sinr.good": "Good SINR — low interference",
    "rule.sinr.fair": "Moderate SINR — slight interference",
    "rule.sinr.warning": "Weak SINR — high interference",
    "rule.sinr.critical": "Critical SINR — severe interference",
    "rc.cause.distance": "Large distance to antenna / cell",
    "rc.cause.obstruction": "Physical obstructions (walls, terrain, vegetation)",
    "rc.cause.congestion": "Network congestion / peak hour",
    "rc.cause.interference": "Interference from other cells or sources",
    "rc.cause.overlap": "Cell overlap (PCI conflict)",
    "rc.cause.none": "No relevant problems detected",
    "rc.meas.repeat_offpeak": "Repeat the measurement off-peak",
    "rc.meas.other_band": "Measure on another band / technology",
    "rc.meas.other_locations": "Measure at several points in the area",
    "rc.meas.pci_scan": "Check neighbouring PCIs / cell scan",
    "rc.step.reposition": "Reposition the device / indoor antenna",
    "rc.step.external_antenna": "Consider a directional external antenna",
    "rc.step.change_band": "Change band or channel",
    "rc.step.reduce_interf": "Reduce nearby interference sources",
    "rc.step.none": "No action needed — healthy signal",
    "net.title": "Network Designer",
    "net.subtitle": "Interactive network topology editor",
    "net.palette": "Equipment",
    "net.add_hint": "Click equipment to add it to the diagram",
    "net.save": "Save topology",
    "net.saved": "Topology saved",
    "net.clear": "Clear",
    "net.validate": "Validate",
    "net.valid": "Topology valid",
    "net.invalid": "Topology issues detected",
    "net.node_props": "Node properties",
    "net.node_label": "Label",
    "net.delete_node": "Delete node",
    "net.connect_hint": "Drag from one node to another to connect",
    "net.no_project": "Select a project to design its topology.",
    "exp.title": "Experiment & Failure Lab",
    "exp.subtitle": "Deterministic, reproducible failure scenarios",
    "exp.scenario": "Scenario",
    "exp.params": "Parameters",
    "exp.results": "Results (simulation)",
    "exp.run": "Run test",
    "exp.availability": "Network availability",
    "exp.downtime": "Downtime",
    "exp.latency": "Average latency",
    "exp.loss": "Packet loss",
    "exp.affected": "Affected users",
    "exp.overall": "Overall state",
    "exp.log": "Event log",
    "exp.save": "Save experiment",
    "exp.saved": "Experiment saved",
    "exp.twin_title": "Live Digital Twin",
    "exp.twin_sub": "Reacts to the controls below in real time · uses the Network Designer topology",
    "exp.twin_no_topo": "This project has no topology yet. Create it in the Network Designer.",
    "exp.twin_controls": "Quick controls",
    "exp.twin_legend": "Legend",
    "exp.lm_title": "Live metrics",
    "exp.throughput": "Throughput",
    "tw.active": "Active",
    "tw.warning": "Warning",
    "tw.failure": "Failure",
    "tw.offline": "Offline",
    "exp.p.ispDown": "Shut down primary ISP",
    "exp.p.backupActive": "Activate backup link",
    "exp.p.apDown": "Disable an Access Point",
    "exp.p.latencyUp": "Simulate latency increase",
    "exp.p.packetLoss": "Simulate packet loss",
    "exp.p.powerLoss": "Simulate power failure",
    "exp.s.primary_isp_outage": "Primary ISP outage",
    "exp.s.backup_activation": "Backup internet activation",
    "exp.s.ap_failure": "Access Point failure",
    "exp.s.increased_latency": "Increased latency",
    "exp.s.packet_loss": "Packet loss",
    "exp.s.power_interruption": "Power interruption",
    "exp.s.ups_operation": "UPS backup operation",
    "st.stable": "Stable",
    "st.degraded": "Degraded",
    "st.critical": "Critical",
    "st.offline": "Offline",
    "log.isp_down": "Primary ISP shut down",
    "log.backup_engaged": "Backup link engaged",
    "log.service_restored_backup": "Service restored via backup",
    "log.total_outage": "Total outage — no backup",
    "log.ap_offline": "Access Point offline",
    "log.latency_spike": "Latency spike detected",
    "log.packet_loss": "Packet loss above threshold",
    "log.power_lost": "Grid power lost",
    "log.ups_holding": "UPS holding critical load",
    "scenario.start": "Simulation start",
    "scenario.end": "Simulation end",
    "rep.title": "Engineering Reports",
    "rep.subtitle": "Generate bilingual technical PDF reports",
    "rep.include": "Sections to include",
    "rep.i.summary": "Project summary",
    "rep.i.topology": "Network topology",
    "rep.i.signal": "Signal data (CST / Unitel)",
    "rep.i.scenarios": "Scenario results",
    "rep.i.recommendations": "Technical recommendations",
    "rep.i.nextsteps": "Next steps",
    "rep.language": "Report language",
    "rep.generate": "Generate PDF report",
    "rep.history": "Generated reports",
    "rep.generated": "PDF report generated",
    "rep.no_project": "Select a project to generate reports.",
    "rep.select_project": "Project",
    "team.title": "Engineering Team",
    "team.subtitle": "Demonstration profiles — no real accounts in this version",
    "team.role.bsgotech_admin": "BSGOTECH Admin",
    "team.role.tecnon_engineer": "TecNon Engineer",
    "team.role.external_reviewer": "External Reviewer",
    "team.perm.bsgotech_admin": "Full management · users · projects · report approval",
    "team.perm.tecnon_engineer": "Assigned projects · create/edit simulations · observations",
    "team.perm.external_reviewer": "Read-only access to shared reports",
    "team.note": "This V0.1 is a frontend prototype. Roles are illustrative and do NOT enforce real security without a backend.",
    "set.title": "Settings",
    "set.subtitle": "Prototype preferences (stored in this browser)",
    "set.language": "Interface language",
    "set.data": "Demonstration data",
    "set.reset_demo": "Reset demonstration data",
    "set.reset_done": "Demonstration data reset",
    "set.about": "About",
    "set.about_text": "NEXIS Virtual Lab V0.1 — isolated frontend prototype. Developed by BSGOTECH. Technical collaboration proposed with TecNon. All data is synthetic.",
    "sync.title": "Sync & Backup",
    "sync.online": "Synced with the team server",
    "sync.connecting": "Connecting to server…",
    "sync.offline": "Offline — working locally",
    "sync.last": "Last sync",
    "sync.about": "Projects, zones, plans, measurements, photos and reports are shared across the TecNon team and synced across devices. A local copy is also kept in this browser.",
    "sync.migration_prompt": "Local data was found on this device that is not yet on the server. Make a backup and import it to share with the team. Nothing will be deleted.",
    "sync.migrate": "Back up and migrate to server",
    "sync.migrated": "Migration complete: {n} project(s) imported, {s} skipped.",
    "sync.backup_local": "Download backup (local)",
    "sync.backup_server": "Download backup (server)",
    "sync.backup_done": "Backup downloaded.",
    "sync.error": "Something went wrong. Please try again.",
    "sync.reset_warning": "Resets only this browser's local copy to the demo state. The team server data is not affected.",
    "hist.title": "Change history",
    "hist.subtitle": "Record of who changed what, per project.",
    "hist.refresh": "Refresh",
    "hist.recent": "Recent activity",
    "hist.all_projects": "All projects",
    "hist.empty": "No activity recorded yet.",
    "pwd.title": "Change my password",
    "pwd.about": "Change your own account password. You need your current password. The new password must be at least 8 characters.",
    "pwd.current": "Current password",
    "pwd.new": "New password",
    "pwd.confirm": "Confirm new password",
    "pwd.save": "Save new password",
    "pwd.done": "Password changed successfully.",
    "pwd.min8": "New password must be at least 8 characters.",
    "pwd.mismatch": "Passwords do not match.",
    "pwd.wrong_current": "Current password is incorrect.",
    "pwd.error": "Could not change the password. Please try again.",
    "nrg.subtitle": "Solar / BESS technical assessment · local prototype data",
    "nrg.local_note": "Data stored only in this browser (no backend). Use Export to create a backup.",
    "nrg.assessment": "Technical assessment",
    "nrg.checklist": "Equipment checklist",
    "nrg.photos": "Photos",
    "nrg.generate_pdf": "Generate PDF",
    "nrg.export": "Export backup",
    "nrg.import": "Import backup",
    "nrg.exported": "Backup exported (JSON)",
    "nrg.imported": "Project imported",
    "nrg.import_err": "Invalid file",
    "nrg.pdf_generated": "HX report generated",
    "nrg.site": "Site name",
    "nrg.solar_kwp": "Solar (kWp)",
    "nrg.battery_kwh": "Battery (kWh)",
    "nrg.pv_modules": "PV modules count",
    "nrg.inverter": "Inverter (generic model)",
    "nrg.system_voltage": "System voltage",
    "nrg.notes": "Technical notes",
    "nrg.group.solar": "Solar photovoltaic",
    "nrg.group.bess": "Storage (BESS)",
    "nrg.status.ok": "OK",
    "nrg.status.issue": "Issue",
    "nrg.status.na": "N/A",
    "nrg.add_photos": "Add photos",
    "nrg.no_photos": "No photos. Add from the gallery or computer.",
    "nrg.caption_ph": "Caption (optional)",
    "nrg.photos_count": "{n} photo(s)",
    "nrg.ck.panels_mounted": "Panels mounted and secured",
    "nrg.ck.panel_orientation": "Correct orientation and tilt",
    "nrg.ck.string_voltage": "String voltage within limits",
    "nrg.ck.mppt_config": "MPPT configuration verified",
    "nrg.ck.dc_protection": "DC protection (fuses/breakers)",
    "nrg.ck.pv_grounding": "PV grounding / earthing",
    "nrg.ck.battery_mounting": "Batteries mounted and secured",
    "nrg.ck.bms_status": "BMS operational",
    "nrg.ck.soc_calibration": "SOC calibration",
    "nrg.ck.ventilation": "Adequate ventilation / cooling",
    "nrg.ck.ac_protection": "AC protection",
    "nrg.ck.inverter_config": "Inverter configuration",
    "nrg.ck.backup_switchover": "Backup switchover tested",
    "nrg.ck.labeling_safety": "Labelling and safety",
    "nrg.survey": "Survey identification",
    "nrg.engineer": "Responsible engineer",
    "nrg.visit_date": "Visit date",
    "nrg.value": "Value",
    "nrg.obs": "Observation",
    "nrg.mode.measured": "Measured",
    "nrg.mode.estimated": "Estimated",
    "nrg.mode.simulated": "Simulated",
    "nrg.auth_title": "Technical Study Authorization",
    "nrg.client": "Client data",
    "nrg.cl_name": "Client",
    "nrg.cl_company": "Company",
    "nrg.cl_nif": "Tax ID (NIF)",
    "nrg.cl_install": "Installation site",
    "nrg.cl_rep": "Representative",
    "nrg.cl_role": "Role",
    "nrg.cl_contacts": "Contacts",
    "nrg.cl_date": "Date",
    "nrg.study_option": "Study type",
    "nrg.study_free": "Free study",
    "nrg.study_paid": "Paid study",
    "nrg.take_photo": "Take photo",
    "nrg.gallery": "Gallery",
    "nrg.pdf_menu": "Generate document",
    "nrg.pdf_auth": "A · Study Authorization",
    "nrg.pdf_report": "B · Solar/BESS Report",
    "nrg.pdf_annex": "C · Photo Annex",
    "nrg.pdf_dossier": "D · Full Technical Dossier",
    "nrg.demo": "DEMONSTRATION PROJECT",
    "auth.login_title": "Sign in to NEXIS Lab",
    "auth.subtitle": "TecNon Team · BSGOTECH",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.signin": "Sign in",
    "auth.signing": "Signing in…",
    "auth.logout": "Log out",
    "auth.err": "Failed. Check your credentials.",
    "auth.set_title": "Set your password",
    "auth.new_password": "New password",
    "auth.confirm_password": "Confirm password",
    "auth.save": "Save password",
    "auth.set_done": "Password set. Redirecting to login…",
    "auth.mismatch": "Passwords do not match.",
    "auth.min8": "At least 8 characters.",
    "auth.invalid_link": "Invalid or expired link.",
    "tm.tab_team": "Team",
    "tm.tab_access": "Email & Password",
    "tm.engineers": "TecNon Engineers",
    "tm.add_eng": "Add engineer",
    "tm.name": "Full name",
    "tm.email": "Professional email",
    "tm.create_access": "Create access",
    "tm.reset": "Reset password",
    "tm.revoke": "Revoke",
    "tm.delete": "Delete",
    "tm.active": "Active",
    "tm.inactive": "Inactive",
    "tm.activate": "Activate",
    "tm.deactivate": "Deactivate",
    "tm.pending_pw": "Password pending",
    "tm.pw_set": "Access set",
    "tm.last_login": "Last login",
    "tm.never": "Never",
    "tm.link_copy": "Copy",
    "tm.link_hint": "Send this single-use link (24h) to the engineer to set the password.",
    "tm.copied": "Link copied",
    "tm.admin_only": "Only BSGOTECH Admin can manage access.",
    "tm.management_title": "Team Management",
    "tm.management_subtitle": "Manage engineers, invitations, roles and security of the TecNon team.",
    "tm.tab_engineers": "Engineers",
    "tm.tab_add": "Add Engineer",
    "tm.tab_pending": "Pending Invitations",
    "tm.tab_roles": "Roles & Permissions",
    "tm.tab_security": "Security",
    "tm.expiry": "Invitation expiry",
    "tm.expiry_24h": "24 hours",
    "tm.expiry_48h": "48 hours",
    "tm.expiry_7d": "7 days",
    "tm.expiry_30d": "30 days",
    "tm.expires": "Expires",
    "tm.edit": "Edit",
    "tm.save": "Saved",
    "tm.cancel": "Cancel",
    "tm.regenerate": "Regenerate link",
    "tm.no_pending": "No pending invitations.",
    "tm.purpose_invite": "Initial invite",
    "tm.purpose_reset": "Password reset",
    "tm.audit": "Audit log",
    "tm.no_audit": "No records yet.",
    "tm.role_admin": "ADMINISTRATOR",
    "tm.role_engineer": "ENGINEER",
    "tm.admin_perms": "Full platform administration\nManage engineers and invitations\nManage projects, documents and settings\nView administrative dashboards\nControl of all permissions",
    "tm.eng_perms": "Access assigned engineering projects\nUpload technical reports and documents\nUpdate technical project information\nView assigned tasks\nNo access to Admin Settings, user management or role assignments",
    "tm.security_note": "Permissions are enforced on the backend. The legitimate Admin is protected and cannot be downgraded or removed by engineers. Deactivated accounts lose their session immediately. Invitation tokens are never exposed in logs.",
    "tm.invite_subject": "Invitation to the NEXIS platform (BSGOTECH)",
    "tm.invite_body": "You have been invited to BSGOTECH's NEXIS platform. Open the link to set your password and sign in:",
    "prof.title": "My Profile",
    "prof.name": "Name",
    "prof.email": "Email",
    "prof.role": "Role",
    "prof.role_admin": "Administrator",
    "prof.role_engineer": "TecNon Engineer",
    "prof.role_admin_full": "BSGOTECH Administrator",
    "prof.photo": "Photo",
    "prof.save": "Save profile",
    "prof.saved": "Profile updated.",
    "prof.name_required": "Please enter a name.",
    "prof.note": "This only changes your name and photo. Your permissions are not changed.",


    "tm.no_engineers": "No engineers yet. Add the first one.",
    // --- Signal Zones ---
    "sz.title": "Signal Zones",
    "sz.add": "Add Signal Zone",
    "sz.add_more": "Add more zones",
    "sz.add_more_sub": "Add as many zones as needed",
    "sz.total": "Total zones",
    "sz.verified": "Verified",
    "sz.pending": "Pending",
    "sz.nosignal": "No signal",
    "sz.open_lab": "Signal Lab",
    "sz.edit": "Edit Zone",
    "sz.duplicate": "Duplicate",
    "sz.archive": "Archive",
    "sz.unarchive": "Unarchive",
    "sz.delete": "Delete",
    "sz.move_up": "Move up",
    "sz.move_down": "Move down",
    "sz.none_selected": "Select a zone to open its Signal Lab.",
    "sz.no_zones": "No zones yet. Add the first signal zone.",
    "sz.show_archived": "Show archived",
    "sz.zone": "Zone",
    "sz.tab.overview": "Overview",
    "sz.tab.meas": "Measurements",
    "sz.tab.photos": "Photos",
    "sz.tab.map": "Map",
    "sz.tab.notes": "Notes",
    "sz.f.name": "Zone name",
    "sz.f.type": "Zone type",
    "sz.f.area": "Approx. area (m²)",
    "sz.f.desc": "Description",
    "sz.f.lat": "Latitude",
    "sz.f.lng": "Longitude",
    "sz.f.location": "Location",
    "sz.f.operator": "Operator",
    "sz.f.connType": "Connection type",
    "sz.f.wifiTech": "Wi-Fi technology",
    "sz.f.status": "Survey status",
    "sz.f.coverage": "Coverage classification",
    "sz.f.coverage_mode": "Classification mode",
    "sz.f.observations": "Notes",
    "sz.f.problems": "Identified problems",
    "sz.f.recommendations": "Recommendations",
    "sz.info": "Zone information",
    "sz.loc": "Location",
    "sz.opnet": "Operator & Network",
    "sz.last_meas": "Last measurement (manual)",
    "sz.no_meas": "No measurements recorded.",
    "sz.wifi": "Wi-Fi",
    "sz.mobile": "Mobile 4G/5G",
    "sz.add_wifi": "Add Wi-Fi",
    "sz.add_mobile": "Add mobile",
    "sz.add_meas": "Add new measurement",
    "sz.add_photos": "Add photos",
    "sz.gen_zone_pdf": "Generate PDF report",
    "sz.w.band": "Frequency",
    "sz.w.channel": "Channel",
    "sz.w.rssi": "RSSI (dBm)",
    "sz.w.download": "Download (Mbps)",
    "sz.w.upload": "Upload (Mbps)",
    "sz.w.latency": "Latency (ms)",
    "sz.w.point": "Measurement point",
    "sz.m.point": "Measurement point",
    "sz.map_title": "Signal Zones Map",
    "sz.map_upload": "Upload map / plan",
    "sz.map_change": "Change map",
    "sz.map_remove": "Remove map",
    "sz.map_none": "No map. Upload a site plan or map.",
    "sz.map_note": "Associate photos and location to zones. Coordinates and areas are not invented.",
    "bp.upload_image": "Image (PNG/JPG)",
    "bp.upload_pdf": "PDF",
    "bp.pages": "Floors / Pages",
    "bp.floor_ph": "Floor name",
    "bp.remove_page": "Remove",
    "bp.zoom_in": "Zoom in",
    "bp.zoom_out": "Zoom out",
    "bp.zoom_reset": "Reset",
    "bp.place_zones": "Place zones",
    "bp.place_hint": "Tap the plan to place the selected zone.",
    "bp.add_point": "Add point",
    "bp.point_hint": "Tap the plan to add a measurement point to the selected zone.",
    "bp.no_plan": "No plan. Upload a site image or PDF.",
    "bp.pdf_loading": "Processing PDF…",
    "bp.pdf_error": "Could not read the PDF. Upload PNG/JPG or try another file.",
    "bp.unplaced": "Zones to place",
    "bp.create_meas_wifi": "Create Wi-Fi measurement",
    "bp.create_meas_mobile": "Create 4G/5G measurement",
    "bp.open_lab": "Open Signal Lab",
    "bp.point_coverage": "Point coverage",
    "bp.layers": "Layers",
    "bp.layer_zones": "Zones",
    "bp.layer_points": "Measurement points",
    "bp.legend": "Legend",
    "bp.remove_marker": "Remove from plan",
    "bp.select_zone_first": "Select a zone from the list first.",
    "bp.plan_in_report": "The annotated plan is included in the PDF report.",
    "sz.photos_title": "Zone photos",
    "sz.no_photos_zone": "No photos in this zone.",
    "sz.meas_history": "Measurement history",
    "sz.caption_ph": "Caption...",
    "sz.no_value": "Not required — leave blank if not measured",
    "sz.class_hint": "Classify the origin of each value.",
    "sz.simlab_title": "Simulation Lab",
    "sz.simlab_sub": "Deterministic CST/Unitel simulation — simulated data, not a real measurement.",
    "sz.simlab_toggle": "Show/hide",
    "cov.strong": "Strong signal",
    "cov.medium": "Medium signal",
    "cov.weak": "Weak signal",
    "cov.none": "No signal",
    "cov.unverified": "Not verified",
    "cov.manual": "Manual",
    "cov.computed": "Computed",
    "zt.reception": "Reception",
    "zt.rooms": "Rooms",
    "zt.restaurant": "Restaurant / Bar",
    "zt.pool": "Pool",
    "zt.garden": "Garden",
    "zt.beach": "Beach",
    "zt.office": "Office",
    "zt.parking": "Parking",
    "zt.exterior": "Exterior",
    "zt.technical": "Technical area",
    "zt.other": "Other",
    "zst.pending": "Pending",
    "zst.verified": "Verified",
    "zst.archived": "Archived",
    "rep.export_a": "Full Project PDF",
    "rep.export_b": "Single Zone PDF",
    "rep.export_c": "Consolidated PDF (Zones)",
    "rep.select_zone": "Select zone",
    "rep.no_zones": "The project has no signal zones.",
    "rep.i.zones": "Per-zone sections",
    "rep.c.title": "Consolidated Coverage Report",
    "rep.c.summary": "Zones Comparative Summary",
    // --- HX Stable Energy v2 ---
    "nrg.doc_a_title": "Document A · Preliminary Technical Study Authorization",
    "nrg.doc_b_title": "Document B · Solar/BESS Technical Survey Form",
    "nrg.auth_status": "Authorization status",
    "nrg.auth.pending": "Pending",
    "nrg.auth.sent": "Sent",
    "nrg.auth.signed": "Signed",
    "nrg.minuta_note": "Document A generates the official BSGOTECH | HX Stable Energy Preliminary Technical Study Request & Authorization (2 pages, 9 sections) with the full text of the original document. Client data, study type and signatures are filled from this form.",
    "nrg.preliminary": "PRELIMINARY TECHNICAL ASSESSMENT",
    "nrg.sec.a": "A · Installation identification",
    "nrg.sec.b": "B · Energy consumption",
    "nrg.sec.c": "C · Load profile",
    "nrg.sec.d": "D · Electrical grid",
    "nrg.sec.e": "E · Existing generators",
    "nrg.sec.f": "F · Interruptions & autonomy",
    "nrg.sec.g": "G · Critical loads",
    "nrg.sec.h": "H · Solar installation area",
    "nrg.sec.i": "I · BESS installation area",
    "nrg.sec.j": "J · Existing Solar/BESS equipment",
    "nrg.sec.analysis": "Preliminary Solar/BESS Analysis",
    "nrg.sec.flow": "Operational flow",
    "f.projectCode": "Unique project code",
    "f.installName": "Installation name",
    "f.installType": "Installation type",
    "f.gps": "GPS coordinates",
    "f.techContact": "Local technical contact",
    "f.visitTime": "Visit time",
    "f.assessmentStatus": "Assessment status",
    "f.monthlyKwh": "Monthly consumption (kWh)",
    "f.invoiceHistory": "Invoice history available",
    "f.avgDailyKwh": "Average daily consumption (kWh)",
    "f.peakKw": "Peak power (kW/kVA)",
    "f.contractedPower": "Contracted/available power",
    "f.peakHours": "Peak consumption hours",
    "f.mainLoads": "Main consuming equipment",
    "f.energyCost": "Electricity cost",
    "f.loadProfileSource": "Load data source",
    "f.loadProfileNotes": "Load profile notes",
    "f.supplyType": "Supply type",
    "f.nominalVoltage": "Nominal voltage",
    "f.frequency": "Frequency (Hz)",
    "f.phases": "Number of phases",
    "f.transformer": "Existing transformer",
    "f.transformerCapacity": "Transformer capacity",
    "f.mainBoard": "Main / distribution board",
    "f.protections": "Existing protections",
    "f.visualState": "Visual state of installations",
    "f.connectionPoints": "Available connection points",
    "f.singleLine": "Single-line diagram (exists?)",
    "f.maker": "Manufacturer",
    "f.model": "Model",
    "f.powerKva": "Power (kVA/kW)",
    "f.fuel": "Fuel",
    "f.consumption": "Fuel consumption",
    "f.hours": "Operating hours",
    "f.condition": "Operational condition",
    "f.switchgear": "Grid/generator switchgear",
    "f.autoManual": "Automatic/Manual",
    "f.outageFrequency": "Outage frequency",
    "f.outageDuration": "Usual duration",
    "f.failureHistory": "Real failure history",
    "f.infoOrigin": "Information source",
    "f.affectedEquip": "Affected equipment",
    "f.continuityNeeds": "Continuity needs",
    "f.desiredAutonomyH": "Desired autonomy (h)",
    "f.loadPriority": "Priority of loads to sustain",
    "f.cl_name": "Equipment",
    "f.cl_qty": "Quantity",
    "f.cl_power": "Nominal power",
    "f.cl_hours": "Usage hours",
    "f.cl_priority": "Priority",
    "f.cl_backup": "Needs backup",
    "f.cl_simultaneous": "Simultaneous operation",
    "f.cl_notes": "Technical notes",
    "f.solarSurface": "Surface (roof/ground/other)",
    "f.solarAreaM2": "Available area (m²)",
    "f.orientation": "Orientation",
    "f.tilt": "Tilt",
    "f.shading": "Shading and obstacles",
    "f.structuralState": "Apparent structural state",
    "f.distanceToConn": "Distance to connection points",
    "f.bessLocation": "Proposed location",
    "f.bessSpace": "Available space",
    "f.bessIndoorOutdoor": "Indoor/Outdoor",
    "f.ventilation": "Ventilation",
    "f.temperature": "Temperature conditions",
    "f.accessibility": "Accessibility",
    "f.proximityBoard": "Proximity to electrical board",
    "f.safetyConditions": "Safety conditions",
    "f.proposedSolarKwp": "Proposed solar power (kWp)",
    "f.proposedBessKwh": "Proposed BESS capacity (kWh)",
    "f.inverterPower": "Inverter power",
    "f.desiredAutonomy": "Desired autonomy",
    "f.estimatedAutonomy": "Estimated autonomy (if computable)",
    "f.operationStrategy": "Preliminary operation strategy",
    "f.techConstraints": "Technical constraints",
    "f.missingData": "Missing data",
    "f.nextPhaseRecs": "Next-phase recommendations",
    "nrg.analysis_note": "PROPOSED values for analysis — they do not represent installed equipment or final sizing. Subject to engineering validation.",
    "nrg.class": "Classification",
    "nrg.class.measured": "Measured",
    "nrg.class.documented": "Documented",
    "nrg.class.estimated": "Estimated",
    "nrg.class.unverified": "Unverified",
    "nrg.class.simulated": "Simulated",
    "nrg.cs.conforme": "Compliant",
    "nrg.cs.nao_conforme": "Non-compliant",
    "nrg.cs.nao_verificado": "Not verified",
    "nrg.cs.nao_aplicavel": "N/A",
    "nrg.photo_category": "Category",
    "pc.counter": "Electric meter",
    "pc.main_board": "Main board",
    "pc.transformer": "Transformer",
    "pc.generators": "Generators",
    "pc.nameplates": "Nameplates",
    "pc.bess_location": "Planned BESS location",
    "pc.solar_area": "Solar roof / ground",
    "pc.connection_points": "Connection points",
    "pc.other": "Other equipment",
    "it.hotel": "Hotel", "it.resort": "Resort", "it.enterprise": "Enterprise", "it.commerce": "Commerce", "it.industry": "Industry", "it.other": "Other",
    "as.draft": "Draft", "as.in_progress": "In progress", "as.completed": "Completed", "as.review": "Internal review",
    "st2.grid": "Public grid", "st2.generator": "Generator", "st2.hybrid": "Hybrid", "st2.other": "Other",
    "ph.mono": "Single-phase", "ph.tri": "Three-phase",
    "lps.meter_history": "Meter history", "lps.ems": "EMS system", "lps.manual": "Manual records", "lps.none": "No history",
    "pr.high": "High", "pr.medium": "Medium", "pr.low": "Low",
    "nrg.add_reading": "Add reading",
    "nrg.no_readings": "No readings. Record manual readings during the visit.",
    "nrg.datetime": "Date/Time",
    "nrg.origin": "Origin",
    "nrg.load_upload": "Upload file (CSV/Excel/PDF)",
    "nrg.load_files": "Attached files",
    "nrg.load_files_note": "File names are recorded locally; content is not automatically processed in this version.",
    "nrg.load_chart": "Recorded readings",
    "nrg.add_generator": "Add generator",
    "nrg.no_generators": "No generators recorded.",
    "nrg.add_load": "Add critical load",
    "nrg.no_loads": "No critical loads recorded.",
    "nrg.remove": "Remove",
    "nrg.backup_q": "Backup",
    "nrg.simul_q": "Simultaneous",
    "nrg.flow.s1": "Create project and client",
    "nrg.flow.s2": "Prepare client authorization",
    "nrg.flow.s3": "Record authorization status",
    "nrg.flow.s4": "Assign responsible engineer",
    "nrg.flow.s5": "Carry out the survey from the phone",
    "nrg.flow.s6": "Add measurements and photos",
    "nrg.flow.s7": "Save draft",
    "nrg.flow.s8": "Identify missing information",
    "nrg.flow.s9": "Complete preliminary assessment",
    "nrg.flow.s10": "Generate technical PDF",
    "nrg.flow.s11": "Submit for BSGOTECH internal review",
    "nrg.flow.s12": "Prepare data for possible analysis with Wattzing",
    "nrg.flow_note": "The platform does not indicate a project was approved by Wattzing without specific confirmation.",
  },
};

export function makeT(lang) {
  const dict = LAB_STRINGS[lang] || LAB_STRINGS.pt;
  return (key, vars) => {
    let s = dict[key] ?? LAB_STRINGS.pt[key] ?? key;
    if (vars) for (const k of Object.keys(vars)) s = s.replace(`{${k}}`, vars[k]);
    return s;
  };
}
